import { render, staticRenderFns } from "./GroupReportThird.vue?vue&type=template&id=70b31569&scoped=true"
import script from "./GroupReportThird.vue?vue&type=script&lang=js"
export * from "./GroupReportThird.vue?vue&type=script&lang=js"
import style0 from "./GroupReportThird.vue?vue&type=style&index=0&id=70b31569&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b31569",
  null
  
)

export default component.exports